"use client";

import { useState } from "react";
import Link from "next/link";
import { useSession, signOut } from "next-auth/react";
import ProfileModal from "./ProfileModal";

export default function Header() {
  const { data: session } = useSession();
  const [isProfileModalOpen, setIsProfileModalOpen] = useState(false);

  const handleLogout = async () => {
    await signOut({ callbackUrl: "/" });
  };

  return (
    <>
      <header className="bg-surface shadow-sm">
        <div className="max-w-6xl mx-auto px-4 py-4 flex justify-between items-center">
          <Link href="/">
            <h1 className="text-2xl font-bold text-blue-500 cursor-pointer">
              루트인 요가
            </h1>
          </Link>
          <div className="flex gap-4 items-center">
            {session ? (
              <>
                <button
                  onClick={() => setIsProfileModalOpen(true)}
                  className="text-text-muted hover:text-blue-500 transition"
                >
                  {session.user?.name || session.user?.email}님
                </button>
                <button
                  onClick={handleLogout}
                  className="text-text-muted hover:text-blue-500"
                >
                  로그아웃
                </button>
              </>
            ) : (
              <>
                <Link
                  href="/login"
                  className="text-text-muted hover:text-blue-500"
                >
                  로그인
                </Link>
              </>
            )}
          </div>
        </div>
      </header>

      <ProfileModal
        isOpen={isProfileModalOpen}
        onClose={() => setIsProfileModalOpen(false)}
      />
    </>
  );
}
